import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Message } from '@eda/shared/models/message.model';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private _messages:WritableSignal<Message[]> = signal([]);

  readonly allMessages = this._messages.asReadonly();

  addToMessage(messageToAdd: Message) {
    this._messages.update(messages => { 
      return [ ...messages, messageToAdd ];
    });
    
  }


  retrieveMessages(): Signal<Message[]> {
    return this.allMessages;
  }

  updateMessage(updatedMessage: Message): void {
    this._messages.update(messages => 
      messages.map(msg => 
        msg.id === updatedMessage.id
          ? { ...msg, ...updatedMessage }
          : msg
      )
    )
  }

  clearMessages(): void {
    this._messages.set([]);
  }

  loadHistory(messages: Message[]): void {
    this.clearMessages();
    messages.forEach(msg => this.addToMessage(msg));
  }

}
